import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface LatexCompileState {
    compilingPaths: Record<string, boolean>;
    startCompile: (path: string) => void;
    finishCompile: (path: string) => void;
}

export const useLatexCompileStore = create<LatexCompileState>()(
    immer((set) => ({
        compilingPaths: {},
        startCompile: (path: string) =>
            set((state) => {
                state.compilingPaths[path] = true;
            }),
        finishCompile: (path: string) =>
            set((state) => {
                delete state.compilingPaths[path];
            }),
    }))
);
